// eslint-disable-next-line import/no-unresolved
import KeenSlider from "https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js";

const { config } = window.BAO.Carousel;
const { setInitialised, addWheelControls, useArrows } =
  window.BAO.Carousel.plugins;
class ProductUpsellsCarousel extends window.BAO.CustomElement() {
  static get requiredElements() {
    return ["slides", "slide"];
  }

  connectedCallback() {
    super.connectedCallback();
    this.carousel = this.setupCarousel();
  }

  setupCarousel() {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: "snap",
        defaultAnimation: {
          duration: config.defaultAnimation.duration,
        },
        dragSpeed: config.dragSpeed,
        slides: {
          perView: "auto",
          spacing: 10,
        },
        breakpoints: {
          "(min-width: 768px)": {
            slides: {
              perView: "auto",
              spacing: 10,
            },
          },
          "(min-width: 901px)": {
            slides: {
              perView: "auto",
              spacing: 10,
            },
          },
        },
      },
      [
        setInitialised(),
        addWheelControls("horizontal"),
        useArrows({
          previous: this.els.previous.element,
          next: this.els.next.element,
          slides: this.els?.slides?.element,
        }),
      ],
    );
  }
}

if (!customElements.get("product-upsells-carousel")) {
  customElements.define("product-upsells-carousel", ProductUpsellsCarousel);
}
